import Component from "../component";
import { getConfig } from "configuration/config";
import { getLocale, getLocaleLang } from '../../helpers/locale';
import Keyboard from 'simple-keyboard';
import 'simple-keyboard/build/css/index.css';



export interface IKioskComponent {
    query?: string;
    showDescription?: boolean;
}
export enum KioskComponentEvents {
    LOGO_CLICKED = "logo_clicked",
    LOGOS_LOADED = "logos_loaded",
    LANGUAGE_CHANGED = "language_changed",
    MAP_RELOAD = "map_reload",
}
export default class KioskComponent extends Component<IKioskComponent> {
    public allSponsors: any[] = [];
    public marqueeRows: any[] = [[], [], [], []];
    public defaultTheme!: any;
    public selectedBuilding!: any;
    public sessionDuration!: number;
    public countdownInterval!: number;
    public TIMEOUT_LIMIT: number = 60;
    public isMapReloaded: boolean = false;
    public keyboardInstance!: Keyboard;
    public activeInput: HTMLInputElement | HTMLTextAreaElement | null = null;
    private isDragging: boolean = false;
    private dragStartX: number = 0;
    private dragStartY: number = 0;
    private overlayStartX: number = 0;
    private overlayStartY: number = 0;
    private boundOnTouchMove: ((e: TouchEvent) => void) | null = null;
    private boundOnTouchEnd: ((e: TouchEvent) => void) | null = null;
    init() {
        this.sessionDuration = 60;
        this.updateSessionCountdown = this.updateSessionCountdown.bind(this);
        this.getSponsoredLogos()
            .then((response: woosmap.map.GeoJSONFeatureCollection) => {
                if (response.features && response.features.length > 0) {
                    const sponsorsData = response.features;
                    this.shuffleSponsorsArray(sponsorsData);
                    this.marqueeRows = [[], [], [], []];
                    sponsorsData.forEach((img, index) => {
                        this.marqueeRows[index % 4].push(img);
                    });
                    this.renderSponsors();
                    // Reposition keyboard now that bottom marquees have content
                    this.resetKeyboardPosition();
                }

            })
            .catch((error) => {
                console.error("Failed to load sponsored logos:", error);
            })
        const $languageSelector = document.getElementById("languageSelector");
        const $logoInstructor = document.getElementById("logo-instruction");
        if ($logoInstructor) {
            $logoInstructor.innerHTML = getLocale().messages.sponsored_logo_selection;
        }
        if ($languageSelector) {
            $languageSelector.innerHTML = getLocale().messages.selectLanguage;
        }
        const $countdownWrapper = document.getElementById('countdownWrapper');
        if ($countdownWrapper) {
            const $linkReset = document.createElement('a');
            $linkReset.id = "lnkReset";
            $linkReset.href = "#";
            $linkReset.innerText = getLocale().messages.resetMap;
            $linkReset.style.visibility = 'hidden';
            $linkReset.style.color = '#e30613';
            $linkReset.addEventListener("click", (event) => {
                event.preventDefault();
                this.resetMap();
            })
            $countdownWrapper.appendChild($linkReset);
        }
        this.initializeLanguageSelector();

    }
    render(): void {
    }
    initCustomKeyboard() {
        this.keyboardInstance = new Keyboard({
            onChange: (value: string): void => {
                if (!this.activeInput) return;

                this.activeInput.value = value;

                // notify third-party widget (autocomplete.js)
                this.activeInput.dispatchEvent(
                    new InputEvent("input", { bubbles: true, inputType: "insertText" })
                );
            },

            onKeyPress: (button: string): void => {
                if (button === "{search}" && this.activeInput) {
                    this.activeInput.dispatchEvent(
                        new KeyboardEvent("keydown", {
                            key: "Enter",
                            bubbles: true
                        })
                    );
                }
            },

            layout: {
                default: [
                    "1 2 3 4 5 6 7 8 9 0",
                    "q w e r t y u i o p",
                    "a s d f g h j k l è",
                    "z x c v b n m ò à {bksp}",
                    "ì ù é {space}"
                ]
            },
            layoutName: "default",

            // Kiosk safety
            physicalKeyboardHighlight: false,
            physicalKeyboardHighlightPress: false,
            preventMouseDownDefault: true,

            // No sound, no animation surprises
            enableTouchEvents: true,
            useMouseEvents: false,

            // Do NOT auto-capitalize
            syncInstanceInputs: false,

            // No input masking tricks
            inputPattern: /[a-z0-9àèéìòù ]/i,

            // Do not clear input automatically
            clearInputOnEnter: false,

            // Disable candidate / IME behavior
            disableCaretPositioning: true,

            display: {
                "{bksp}": "⌫",
                "{space}": getLocale().keyboard.space
            },
        });

        this.initDragHandle();
        this.initCloseButton();
    }
    initCloseButton(): void {
        const btn = document.getElementById("keyboard-close");
        if (!btn) return;
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (this.activeInput) {
                this.activeInput.blur();
            }
            this.hideKeyboard();
        });
    }
    initDragHandle(): void {
        const handle = document.getElementById("keyboard-drag-handle");
        if (!handle) return;

        handle.addEventListener("touchstart", (e: TouchEvent) => {
            e.preventDefault();
            e.stopPropagation();

            const overlay = document.getElementById("keyboard-overlay");
            if (!overlay) return;

            this.isDragging = true;
            overlay.classList.add("keyboard-dragging");

            const touch = e.touches[0];
            this.dragStartX = touch.clientX;
            this.dragStartY = touch.clientY;

            const rect = overlay.getBoundingClientRect();
            this.overlayStartX = rect.left;
            this.overlayStartY = rect.top;

            this.boundOnTouchMove = this.onDragMove.bind(this);
            this.boundOnTouchEnd = this.onDragEnd.bind(this);

            document.addEventListener("touchmove", this.boundOnTouchMove, { passive: false });
            document.addEventListener("touchend", this.boundOnTouchEnd);
        }, { passive: false });
    }
    onDragMove(e: TouchEvent): void {
        if (!this.isDragging) return;
        e.preventDefault();

        // Keyboard is leaving default position
        document.documentElement.style.setProperty('--keyboard-height', '0px');

        const overlay = document.getElementById("keyboard-overlay");
        if (!overlay) return;

        const touch = e.touches[0];
        const deltaX = touch.clientX - this.dragStartX;
        const deltaY = touch.clientY - this.dragStartY;
        const buffer = 100;

        const w = overlay.offsetWidth;
        const handleHeight = 56 + buffer;

        // Keep drag handle visible: top edge clamped at 0 so handle never goes off-screen
        const newX = Math.max(-w + handleHeight, Math.min(this.overlayStartX + deltaX, window.innerWidth - handleHeight));
        const newY = Math.max(0, Math.min(this.overlayStartY + deltaY, window.innerHeight - handleHeight));

        overlay.style.left = `${newX}px`;
        overlay.style.top = `${newY}px`;
        overlay.style.bottom = "auto";
        overlay.style.right = "auto";
    }
    onDragEnd(): void {
        this.isDragging = false;

        const overlay = document.getElementById("keyboard-overlay");
        overlay?.classList.remove("keyboard-dragging");

        if (this.boundOnTouchMove) {
            document.removeEventListener("touchmove", this.boundOnTouchMove);
        }
        if (this.boundOnTouchEnd) {
            document.removeEventListener("touchend", this.boundOnTouchEnd);
        }
        this.boundOnTouchMove = null;
        this.boundOnTouchEnd = null;

    }
    resetKeyboardPosition(): void {
        const overlay = document.getElementById("keyboard-overlay");
        if (!overlay) return;

        // Center the keyboard within the #app (map container) area
        const app = document.getElementById("app");
        if (!app) return;

        const appRect = app.getBoundingClientRect();
        const overlayWidth = overlay.offsetWidth;
        const overlayHeight = overlay.offsetHeight;

        const centerLeft = appRect.left + (appRect.width - overlayWidth) / 2;
        const centerTop = appRect.top + (appRect.height - overlayHeight) / 2;

        overlay.style.left = `${centerLeft}px`;
        overlay.style.top = `${centerTop}px`;
        overlay.style.right = "auto";
        overlay.style.bottom = "auto";

        // Keyboard overlaps the map — no need to shrink map height
        document.documentElement.style.setProperty('--keyboard-height', '0px');
    }
    renderSponsors() {
        this.removeExistingMarquees();

        for (let i = 0; i < 4; i++) {
            this.createMarquee(i);
        }
        requestAnimationFrame(() => {
            this.restartMarqueeAnimation(".marquee");
        });
    }
    createMarquee(rowIndex: number) {
        const marquee = document.querySelector(`#marquee-container-${rowIndex + 1} .marquee`);
        const marqueeContent = document.createElement('div');
        marqueeContent.classList.add('marquee-content');

        if (marquee) {
            this.marqueeRows[rowIndex].forEach((sponsor: any) => {
                const img = document.createElement('img');
                img.src = sponsor.properties.Sponsored_URL;
                img.onerror = () => {
                    console.warn(`Skipped broken image: ${sponsor.properties.name}`);
                    img.remove();
                };

                img.dataset.ref = sponsor.properties.ref;
                marqueeContent.appendChild(img);
            });
            marquee.addEventListener('click', (e) => {
                const target = e.target as HTMLElement;
                if (target.tagName === 'IMG' && target.dataset.ref) {
                    this.startSessionCountdown();
                    this.emit(KioskComponentEvents.LOGO_CLICKED, target.dataset.ref);
                }
            });
            const marqueeClone = marqueeContent.cloneNode(true);
            marquee.appendChild(marqueeContent);
            marquee.appendChild(marqueeClone);
        }
    }
    shuffleSponsorsArray(array: any[]) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
    }
    getSponsoredLogos(): Promise<woosmap.map.GeoJSONFeatureCollection> {
        return new Promise<woosmap.map.GeoJSONFeatureCollection>((resolve, reject) => {
            const indoorService = new woosmap.map.IndoorService();
            const cbSponsoredLogos = (response: woosmap.map.GeoJSONFeatureCollection) => {
                if (response && response.features && response.features.length > 0) {
                    this.allSponsors = response.features;
                    resolve(response);
                }
                else {
                    // reject(new Error("No sponsors found."));
                    resolve([] as woosmap.map.GeoJSONFeatureCollection)
                }
            };
            indoorService.search(getConfig().map.indoorRendererOptions.venue || `sdm_${getConfig().map.eventYear}_${getConfig().map.env}`, "", cbSponsoredLogos, null, null, `Is_Sponsored:="yes"`);
        });
    }
    initializeLanguageSelector(): void {
        const languageSelector = document.querySelector(".sl-nav");

        if (languageSelector) {
            const languageOptions = languageSelector.querySelectorAll(".sl-flag");

            languageOptions.forEach((flagElement) => {
                const parentElement = flagElement.parentElement;
                const elementLang = flagElement.getAttribute("data-lang");
                if (elementLang) {
                    if (elementLang.toLowerCase() === getLocaleLang().toLowerCase()) {
                        const nextSibling = flagElement.nextElementSibling;
                        if (nextSibling) {
                            nextSibling.classList.add("active");
                        }
                        this.selectLanguage(getLocaleLang());
                    }
                }
                if (parentElement) {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    parentElement.addEventListener("click", (event: MouseEvent) => {
                        const selectedLanguageCode = flagElement.getAttribute("data-lang");
                        window.lang = selectedLanguageCode || getLocaleLang();
                        languageOptions.forEach((option) => {
                            const span = option.parentElement?.querySelector("span");
                            span?.classList.remove("active");
                        });
                        const nextSibling = flagElement.nextElementSibling;

                        if (selectedLanguageCode) {
                            this.selectLanguage(selectedLanguageCode);
                        }
                        if (nextSibling) {
                            nextSibling.classList.add("active");
                        }
                    });
                }
            });
        }

    }
    selectLanguage(languageCode: string): void {
        const langElement = document.getElementById("selectdLang");
        if (langElement) {
            langElement.innerHTML = `<b>${languageCode.toString().toUpperCase()}</b>`;
        }
        this.emit(KioskComponentEvents.LANGUAGE_CHANGED, languageCode);
        const $logoInstructor = document.getElementById("logo-instruction");
        if ($logoInstructor) {
            $logoInstructor.innerHTML = getLocale().messages.sponsored_logo_selection;
        }
    }
    updateSessionCountdown() {
        const countdownElement = document.getElementById("countdownText");
        const $lnkReset = document.getElementById("lnkReset");
        const minutes = Math.floor(this.sessionDuration / 60);
        const seconds = this.sessionDuration % 60;
        if (countdownElement && $lnkReset) {
            countdownElement.innerHTML = `${getLocale().messages.sessionReset} <span style="color: red;font-family: monospace;font-weight:500">${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? "0" + seconds : seconds}</span> ${minutes < 1 ? getLocale().messages.seconds : getLocale().messages.minute}`;
            $lnkReset.style.visibility = 'visible';
            this.sessionDuration--;
            if (this.sessionDuration < 0) {
                clearInterval(this.countdownInterval);
                this.sessionDuration = this.TIMEOUT_LIMIT;
                countdownElement.textContent = "";
                this.resetMap();
            }
        }
    }
    startSessionCountdown() {
        this.sessionDuration = this.TIMEOUT_LIMIT;
        this.clearCountdownInterval();
        this.countdownInterval = setInterval(this.updateSessionCountdown, 1000);
    }
    clearCountdownInterval() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
            this.countdownInterval = 0;
        }
    }
    resetMap(): void {
        const countdownElement = document.getElementById("countdownText");
        const $lnkReset = document.getElementById("lnkReset");
        if (countdownElement && $lnkReset) {
            countdownElement.textContent = "";
            $lnkReset.style.visibility = 'hidden';
        }
        this.sendGAEvent();
        this.clearCountdownInterval();
        this.resetKeyboardPosition();
        this.isMapReloaded = !this.isMapReloaded;
        this.emit(KioskComponentEvents.MAP_RELOAD, this.isMapReloaded);
        // location.reload();
    }
    sendGAEvent(): void {
        const currentTimeMillis: number = new Date().getTime();
        const currentUnixTimestamp: number = Math.floor(currentTimeMillis / 1000);
        const queryParam = this.state.query?.split('=');
        const kiosk = queryParam && queryParam?.length > 1 ? queryParam[1] : '';
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "session_rest",
            timestamps: currentUnixTimestamp,
            content_id: kiosk,
            items: undefined,
            search_term: undefined,
            item_name: undefined,
            nav_from: undefined,
            nav_to: undefined,
            content_type: undefined,
            click_location: undefined,
        });
    }
    removeExistingMarquees() {
        const marquees = document.querySelectorAll(".marquee-content");
        if (marquees.length > 0) {
            marquees.forEach((el) => { el.remove() });
        }
    }
    restartMarqueeAnimation(selector: string): void {
        requestAnimationFrame(() => {
            const marquees = document.querySelectorAll<HTMLElement>(selector);
            marquees.forEach((el) => {
                el.style.animation = "none"; // Stop the animation
                void el.offsetWidth; // Force reflow
                el.style.animation = ""; // Restart animation
            });
        });
    }
    disableSystemKeyboard() {
        const observer = new MutationObserver(() => {
            const inputs = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>("input, textarea");

            inputs.forEach(input => {
                if (!input.dataset.kioskPatched) {
                    this.patchInput(input);
                }
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

    }
    patchInput(input: HTMLInputElement | HTMLTextAreaElement) {
        input.dataset.kioskPatched = "true";

        // Skip non-text inputs (checkboxes, radios, buttons)
        const textTypes = ["text", "search", "email", "url", "tel", "password", ""];
        if (input instanceof HTMLInputElement && !textTypes.includes(input.type)) {
            return;
        }

        input.setAttribute("inputmode", "none");

        // Use touchstart to suppress system keyboard while keeping input focusable.
        // Allow native clear (X) button on search inputs to remain tappable
        // by skipping preventDefault when the touch is on the right edge.
        input.addEventListener("touchstart", (e) => {
            const te = e as TouchEvent;
            if (input.type === "search" && te.touches && te.touches.length > 0) {
                const rect = input.getBoundingClientRect();
                const touchX = te.touches[0].clientX;
                if (touchX > rect.right - 40) {
                    return;
                }
            }
            e.preventDefault();
            input.focus();
            this.activateKeyboard(input);
        }, { passive: false });

        // Fallback for pointer/click events
        input.addEventListener("click", () => {
            this.activateKeyboard(input);
        });

        // Handle programmatic focus (e.g. panel opening with input auto-focused)
        input.addEventListener("focus", () => {
            this.activateKeyboard(input);
        });

        // If this input already has focus (patched after focus fired), activate now
        if (document.activeElement === input) {
            this.activateKeyboard(input);
        }

        // Hide keyboard when input loses focus
        input.addEventListener("blur", () => {
            setTimeout(() => {
                if (this.activeInput === input && document.activeElement !== input) {
                    this.hideKeyboard();
                }
            }, 200);
        });

        // Hide keyboard when native clear (X) button on search inputs is tapped.
        // The native X clears the full value at once, unlike virtual keyboard backspace
        // which removes one character at a time via our onChange handler.
        if (input.type === "search") {
            let prevLength = input.value.length;
            input.addEventListener("input", (e: Event) => {
                const isVirtualKeyboard = (e as InputEvent).inputType === "insertText";
                if (!isVirtualKeyboard && prevLength > 1 && input.value === "") {
                    this.hideKeyboard();
                }
                prevLength = input.value.length;
            });
        }
    }
    showKeyboard() {
        const el = document.getElementById("keyboard");
        if (el) el.style.display = "block";
        const overlay = document.getElementById("keyboard-overlay");
        if (!overlay) return;

        requestAnimationFrame(() => {
            overlay.classList.add("keyboard-visible");
            this.resetKeyboardPosition();
        });
    }
    detachActiveInput() {
    const isItineraryInput = this.activeInput?.closest('.itinerary-build') !== null;
    if (!isItineraryInput) {
        this.keyboardInstance.clearInput();
    }
    this.activeInput = null;
}
    hideKeyboard() {
        this.detachActiveInput();

        const el = document.getElementById("keyboard");
        if (el) el.style.display = "none";

        const overlay = document.getElementById("keyboard-overlay");
        overlay?.classList.remove("keyboard-visible");

        document.documentElement.style.setProperty('--keyboard-height', '0px');
    }
    activateKeyboard(
        input: HTMLInputElement | HTMLTextAreaElement
    ): void {
        if (this.activeInput === input) {
            return;
        }
        this.activeInput = input;
        this.keyboardInstance.setInput(input.value || "");
        this.showKeyboard();
    }
    applyKeyboardOffset() {
        const keyboard = document.getElementById("keyboard-overlay");
        if (!keyboard) return;

        const keyboardHeight = keyboard.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--keyboard-height', `${keyboardHeight}px`);
    }
}
